import React from 'react';
import Modal from 'shared/components/modal';
import UserService from 'src/services/UserService';

interface Props {
  onClickDeleteAccount: () => void;
  setTermsOfUseConfirmed: (confirmed: boolean) => void;
}

const TERMS_OF_USE_URL = '/terms-of-use';
const PRIVACY_POLICY_URL = '/privacy-policy';

const AcceptTermsOfUseModal = ({onClickDeleteAccount, setTermsOfUseConfirmed}: Props) => {
  const acceptTermsOfUse = (): void => {
    UserService.confirmTermsOfUse().then(() => setTermsOfUseConfirmed(true));
  };

  return (
    <Modal show>
      <Modal.TextHeader>Terms of Use and Privacy Policy</Modal.TextHeader>
      <Modal.Body>
        <p>
          In order to continue using Raise Me, you must agree with our&nbsp;
          <a href={TERMS_OF_USE_URL} target="_blank" rel="noopener noreferrer">
            Terms of Use
          </a>
          &nbsp;and&nbsp;
          <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
            Cookie and Privacy Policy
          </a>
        </p>
        <p>If you do not wish to agree, you must delete your Raise Me account.</p>
        <p>
          By clicking <strong>Agree &amp; Continue</strong>, you agree with our&nbsp;
          <a href={TERMS_OF_USE_URL} target="_blank" rel="noopener noreferrer">
            Terms of Use
          </a>
          &nbsp;and&nbsp;
          <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
            Cookie and Privacy Policy
          </a>
        </p>
      </Modal.Body>
      <Modal.Footer
        primaryButton={{
          text: 'Agree & Continue',
          onClick: acceptTermsOfUse,
        }}
        secondaryButton={{
          text: 'Delete Account',
          color: 'red',
          rightAligned: true,
          onClick: onClickDeleteAccount,
        }}
      />
    </Modal>
  );
};

export default AcceptTermsOfUseModal;
